/* eslint-disable */
export default {
    init() {
        // JavaScript to be fired on all pages
        $(document).ready(function(){
            // Burger
            $('.burger').click(function(){
                if($(this).hasClass('burger--close')){
                    $(this).removeClass('burger--close');
                    $('.menu-burger').removeClass('menu-burger--open');
                    $('body').removeClass('menu-burger-is-open');
                }
                else{
                    $(this).addClass('burger--close');
                    $('.menu-burger').addClass('menu-burger--open');
                    $('body').addClass('menu-burger-is-open');
                }
            })

            $('.menu-burger__overlay').click(function(){
                $('.burger').removeClass('burger--close');
                $('.menu-burger').removeClass('menu-burger--open');
                $('body').removeClass('menu-burger-is-open');
            })

            $('.program__body__day').click(function(evt) {
                evt.preventDefault();
                $('.program__body__day').removeClass('is-active');
                $(this).addClass('is-active');
                manageprogram();
            });

            function manageprogram(){
                var item = $('.program__body__day.is-active').data('attr');
                $('.program__body__details').stop(false, true, true).fadeOut(400);
                $('.program__body__details').removeClass('is-active');
                $('.program__body__details[data-attr="'+item+'"]').delay(400).stop(false, true, true).fadeIn();
            }

            // $('input').change(function(){
            //     if($('input').focus()){
            //         $(this).parent().addClass('field-focus');
            //         if($(this).val() == ''){
            //             if($(this).hasClass('field-focus')){
            //                 $(this).parent().removeClass('field-focus');
            //             }
            //         }
            //     }
            // })

            $('select[name="count_person"]').change(function() {
                let countPerson = parseInt($(this).val());
                let currentCountPerson = parseInt($('#row-dynamic-person .collapse').length);
                if(currentCountPerson > countPerson) {
                    for(let i = currentCountPerson; i >= countPerson; i --) {
                        $('#row-dynamic-person .collapse').eq(i).remove();
                    }
                }
                else if(currentCountPerson < countPerson) {
                    for(let i = currentCountPerson; i < countPerson; i ++) {
                        let j = i+1;
                        let originRow = $('#row-to-clone .collapse').first();
                        let rowClone = originRow.clone();
                        let rowCloneHtml = rowClone[0].outerHTML;
                        rowCloneHtml = rowCloneHtml.replace(/XXX/g,i).replace(/YYY/g,j).replace(/ZZZ/g,'').replace(/data-required="1"/g,'required');
                        $('#row-dynamic-person').append(rowCloneHtml);
                        $('#row-dynamic-person .collapse:last .check-age-plus, #row-dynamic-person .collapse:last .check-age-minus').change(function(evt) {
                            updateTotal();
                        });
                        $('#row-dynamic-person .collapse:last input').change(function(){
                            if($('input').focus()){
                                $(this).parent().addClass('field-focus');
                                if($(this).val() == ''){
                                    if($(this).hasClass('field-focus')){
                                        $(this).parent().removeClass('field-focus');
                                    }
                                }
                            }
                        })
                    }
                }
                updateTotal();

            });

            function updateTotal() {
                let countChild = $('.check-age-minus:checked').length;
                let countParent = $('.check-age-plus:checked').length;
                let total = countChild*25+countParent*50+100;
                $('#amount-register').html(total);
                $('#total-parent').html(countParent+1);
                $('#total-child').html(countChild);
            }

            $('#form-register').submit(function(evt) {
                evt.preventDefault();
                $('#form-register button').addClass('loading').prop('disabled',true);
                $('#form-register .errors').addClass('d-none');
                let formData = $('form#form-register').serialize();
                $.ajax({
                    url: vetinwebevent.ajax_url,
                    method: 'POST',
                    data: formData
                }).done(function (data) {
                    if(data.success != true) {
                        $('#form-register .errors').removeClass('d-none');
                        $('#form-register button').removeClass('loading').prop('disabled',false);
                    }
                    else {
                        $('#form-register button').addClass('loading').delay(2).removeClass('loading').addClass('valid').html('Inscription validée. <i class="fas fa-check"></i>');
                    }
                });
            });

            // Videos ajax
        

            var filter = {'edition': 'all', 'category': 'all'};
            var page = 1;

            var containerList = $('main .videos-wrapper');
            var showMore = $('.actions-ajax');
            var showMoreBtn = $('.actions-ajax .btn');

            $('.videos-wrapper .video').each(function(){
                $(this).css({
                    'height': $(this).width()/1.7737
                })
            });


            // $('.cats-secondary').slick({
            //     slidesToShow: 1,
            //     slidesToScroll: 1,
            //     // centerMode: true,
            //     // centerPadding: '5%',
            //     infinite: false,
            //     arrows: false,
            //   });

            $('.cats-primary .cat').click(function (event) {
                $('.cats-primary .cat').removeClass('is-active');
                filterCat(event, $(this));
            });

            $('.cats-secondary .cat').click(function (event) {
                $('.cats-secondary .cat').removeClass('is-active');
                filterCat(event, $(this));
            });

            function filterCat(event, that){
                event.preventDefault();

                that.addClass('is-active');
                var filterValue = that.data('filter');
                var type = that.data('type');

                if(type == 'category'){
                    filter.category = filterValue
                }
                if(type == 'edition'){
                    filter.edition = filterValue
                }

                console.log(type);
                console.log(filterValue);
                containerList.empty();
                showMore.hide();
                refreshArticle();
            }
        
            function refreshArticle(){
                containerList.addClass('loading');
                $.ajax({
                  url: vetinwebevent.ajaxurl,
                  method: "POST",
                  dataType: "json",
                  data: 
                    {
                      action: "getPost",
                      filter: filter,
                      security: vetinwebevent.ajax_nonce,
                      page: page
                    }
                })
                .done(function( data ) {
                    console.log(data);
                    containerList.removeClass('loading');
                    if(data.items != '') {
                        containerList.append(data.items);
                    } 
                    // if(data.more == 'yes') {
                    //     showMore.show();
                    //     showMoreBtn.removeAttr("disabled");
                    //     showMoreBtn.data('pagination',page);
                    // }
                    // else {
                    //     showMore.hide();
                    // }
                });
            }
        });
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/routes/common.js